/**
 * Non Post Order Details
 */
// React
import React, { useState, useEffect, useContext } from "react";

// Context
import AuthContext from "../../../authContext";

//UI
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import JalaliUtils from "@date-io/jalaali";
import { Controller, useForm } from "react-hook-form";

import {
  Grid,
  Button,
  Divider,
  TextField,
  FormHelperText,
  MenuItem,
  FormControl,
  Select,
  RadioGroup,
  FormControlLabel,
  Radio,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
} from "@material-ui/core";

// Components
import Can from "../../Can";

// Helper
import {
  translate,
  formaterPhoneNumber,
  packegeCounter,
  disablePrevDateByHour,
  convertPersianDigit2English,
  checkHourisPast,
  removeEmptyValueObject,
} from "../../../utils/helpers";
import jMoment from "moment-jalaali";
import handleNotfication from "../../../utils/handleNotfication";
import { isEmpty } from "lodash";

// Type
import {
  DatePicker,
  MuiPickersUtilsProvider,
  TimePicker,
} from "@material-ui/pickers";
import { Card } from "@material-ui/core";
import handleError from "../../../utils/handleError";
import ordersRepository from "client-sdk/src/Repository/orders-repository";
import { mdiClose, mdiPencilOutline } from "@mdi/js";
import { Icon } from "@mdi/react";
import {
  rulesAdminChangeOrderStatus,
  rulesOrderStatus,
} from "../../../utils/rulesOrderStatus";
import {
  UpdateOrderDeliveryCost,
  UpdateOrderPostTrackingCode,
} from "client-sdk/src/orders/orders";
import { Client } from "client-sdk/src";
import { Status } from "client-sdk/src/users/interface";
import theme from "../../../theme";
import fillmentTypes from "client-sdk/src/orders/getFulfillmentTypes";
import shippingDefinitions from "client-sdk/src/orders/shippingDefinitions";
import { useCutoffHandler } from "../../../utils/hook/useGetCutoffList";
import { convertDatePersianToEnglish } from "../../../utils/helpers";
import { FillmentTypesProps } from "./types";
import moment from "moment";

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& > *": {
        "@media (max-width: 768px)": {
          margin: theme.spacing(0),
        },
      },
    },
    textInput: {
      color: "#8a8a8a",
      "& input, .MuiSelect-root": {
        padding: "6px 0 12px !important",
      },

      "& .MuiInput-underline::before": {
        borderBottom: "1px solid #d8d8d8 !important",
      },
    },
    paper: {
      marginTop: "36px",
      marginBottom: "36px",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: "1px solid #ddd",
      borderRadius: "4px",
      "@media (max-width: 768px)": {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    item: {
      marginBottom: "8px",
      display: "flex",
      alignSelf: "center",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: "scale(-1, 1)",
    },
    divider: {
      width: "98%",
      margin: "10px auto",
    },
    label: {
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 600,
      // color: '#8A8A8A',
      marginRight: "10px",
      flex: 0.5,
    },
    headerBox: {
      display: "flex",
      alignItems: "center",
      marginBottom: "28px",
    },
    contentlabelTitle: {
      position: "relative",
      color: theme.palette.gray.light,
      marginLeft: "40px",
      fontSize: "14px",
      fontWeight: 500,
      "&:before": {
        content: '"-"',
        position: "absolute",
        left: "-20px",
      },
    },
    loading: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "50vh",
      alignSelf: "center",
      justifyContent: "center",
      background: "#ccc",
    },
    changStatusIcon: {
      marginRight: "10px",
      position: "absolute",
    },
    changStatusBox: {
      display: "flex",
      textAlign: "left",

      fontWeight: 400,
      fontSize: "14px",
    },
    renderValue: {
      paddingLeft: "32px",
    },
    radioGroup: {
      margin: "-8px 0",
    },
    radioGroupItem: {
      borderBottom: "1px solid #D8D8D8",
      marginRight: "-8px",
      padding: "8px 16px",
      "&:last-child": {
        borderBottom: "0px",
      },
    },
    cancelTitle: {
      fontSize: "16px",
      fontWeight: 500,
      textAlign: "justify",
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    submitbtn: {
      border: "none",
      backgroundColor: "#DFA01F",
      padding: "8px",
      color: "#fff",
      borderRadius: "5px",
      fontWeight: 600,
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#c9911e",
      },
      width: "100%",
    },
    editIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: theme.palette.blue.main,
      },
    },
    card: {
      marginBottom: "14px",
      overflow: "visible !important",
      padding: "14px",
      paddingBottom: "0",
      "@media (max-width: 768px)": {
        overflow: "auto",
      },
    },
    contentBox: {
      marginTop: "-1px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: "14px",
      fontWeight: 500,
      textAlign: "right",
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: "10px",
      fontWeight: 400,
    },

    missingOppositeContent: {
      "&::before": {
        flex: "none",
      },
    },
    paperHistory: {
      alignItems: "center",
    },
  })
);

const token = localStorage.getItem("token") || "";
export function Detailwithedit(props: any) {
  moment.locale("en");
  const date = new Date();
  const formattedDate = moment(date).format("YYYY-MM-DD");

  const authContext = useContext(AuthContext);
  const [editMode, setEditMode] = useState(false as boolean);
  const [orderDeliveryCost, setOrderDeliveryCost] = useState<any>(null);
  const [previewState, setPreviewState] = useState("CANCELLED");
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [postTrackingCode, setPostTrackingCode] = useState<null | string>(null);
  const [deliveryTime, setDeliveryTime] = useState<any>("");
  const [stateFillmentTypes, setStateFillmentTypes] = useState<any>([]);
  const [shippingdefinitions, setshippingdefinitions] = useState<any>([]);
  const [curierDTOList, setCurierDTOList] = useState<any>([]);
  const [dateInDatePiker, setDateInDatePiker] = useState<any>("");
  const [isDisabledDeliveryService, setIsDisabledDeliveryService] =
    useState(false);

  const classes = useStyles();

  const {
    handleSubmit,
    errors,
    watch,
    setValue,
    getValues,
    register,
    control,
    reset,
  } = useForm({
    defaultValues: {
      orderType: props.order.orderType,
      deliveryDate: null,
      fulfillmentTypeId: "",
      deliveryServiceId: "",
      courierId: "",
      cutoffId: "",
      deliveryStartTime: props.order.deliveryStartTime,
      deliveryEndTime: props.order.deliveryEndTime,
      origin: "",
      destination: "",
      customerName: "",
      customerNationalCode: "",
      customerMobileNumber: "",
      customerPhoneNumber: "",
      customerProvince: "",
      customerCity: "",
      customerZipCode: props.order.customerZipCode,
      deliveryType: "",
      customerAddress: "",
    },
  });

  const fulfillmentTypeId = watch("fulfillmentTypeId");
  const courierId = watch("courierId");
  const deliveryServiceId = watch("deliveryServiceId");
  const deliveryDate = watch("deliveryDate");
  const cutoffId = watch("cutoffId");

  const formattedDateSelected = moment(deliveryDate).format("YYYY-MM-DD");
  const dateSelected = convertDatePersianToEnglish(formattedDateSelected);

  const { listCutoff } = useCutoffHandler({
    courierId,
    dateSelected,
    fulfillmentTypeId,
    setDateInDatePiker,
    setValue,
    editMode,
  });

  const [orderType, setOrderType] = useState<null | string>(
    props.order.orderType
  );
  const [deliveryTypeValue, setDeliveryTypeValue] = useState<any>(
    watch("deliveryType")
  );
  const values = getValues();

  useEffect(() => {
    if (!isEmpty(props.order)) {
      const {
        orderType,
        deliveryDate,
        deliveryStartTime,
        deliveryEndTime,
        fulfillmentTypeId,
        deliveryServiceId,
        courierId,
        cutoffId,
        deliveryType,
        customerName,
        customerAddress,
        customerCity,
        customerNationalCode,
        customerPhoneNumber,
        customerMobileNumber,
        customerProvince,
        customerZipCode,
        trackingCode,
        description,
        fulfillmentWarehouseId,
        centerId,
        customerLat,
        customerLon,
      } = props.order;
      const payload = {
        orderType,
        deliveryDate,
        deliveryStartTime: deliveryDate + " " + deliveryStartTime,
        deliveryEndTime: deliveryDate + " " + deliveryEndTime,
        deliveryType,
        customerName,
        fulfillmentTypeId,
        courierId,
        deliveryServiceId,
        cutoffId,
        customerAddress,
        customerCity,
        customerNationalCode,
        customerPhoneNumber,
        customerProvince,
        customerMobileNumber,
        customerZipCode,
        trackingCode,
        description,
        origin: orderType === "FROM_CENTER" ? centerId : fulfillmentWarehouseId,
        destination: orderType === "TO_CENTER" ? centerId : null,
      };
      reset(payload);
    }
  }, [props.order]);

  useEffect(() => {
    if (
      values.deliveryDate &&
      checkHourisPast(
        Number(values.deliveryTime?.substring(0, 2)),
        values.deliveryDate
      )
    )
      setValue("deliveryTime", "");
  }, [values.deliveryDate]);

  useEffect(() => {
    if (props.order?.deliveryCost) {
      setOrderDeliveryCost(props.order?.deliveryCost);
    }
  }, [props.order]);

  const handleChangeDeliveryCost = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOrderDeliveryCost(e.target?.value!);
  };

  const submitOrderDeliveryCost = async () => {
    try {
      const makeRequest = new UpdateOrderDeliveryCost()
        .id(props.order.id)
        .data(orderDeliveryCost)
        .build();
      const client = new Client(token);
      await client.execute(makeRequest);
      handleNotfication("هزینه ارسال با موفقیت ثبت شد", "success");
    } catch (err) {
      handleNotfication(
        "تغییر کد پیگیری پست ثبت نشد دوباره تلاش کنید",
        "error"
      );
    }
  };

  const handleDeliveryDateChange = (date: any) => {
    setValue(
      "deliveryDate",
      convertPersianDigit2English(date.format("YYYY-MM-DD"))
    );
    setValue("deliveryTime", "");
  };

  const handleDisableTime = (hour: number) => {
    return (
      checkHourisPast(hour, values.deliveryDate) &&
      props.order.deliveryTypeValue !== "VIP"
    );
  };

  const handleChangeTrackingCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPostTrackingCode(e.target?.value!);
  };

  const handleOpenConfirmUpdateState = (body: Status) => {
    setOpenConfirmUpdateState(true);
    setPreviewState(body);
  };

  const submitPostTrackingCode = async () => {
    // @ts-ignore
    try {
      const makeRequest = new UpdateOrderPostTrackingCode()
        .id(id)
        .data(postTrackingCode)
        .build();
      const client = new Client(token);
      await client.execute(makeRequest);
      handleNotfication("کد پیگیری پست با موفقیت ثبت شد", "success");
    } catch (err) {
      handleNotfication(
        "تغییر کد پیگیری پست ثبت نشد دوباره تلاش کنید",
        "error"
      );
    }
  };

  const handleUpdateOrders = (data) => {
    const {
      customerAddress,
      customerCity,
      customerMobileNumber,
      customerName,
      customerProvince,
      customerZipCode,
      customerNationalCode,
      deliveryDate: deliver,
      // deliveryTime,
    } = data;

    const customerInfo = {
      customerCity,
      customerMobileNumber,
      customerName,
      customerNationalCode,
      customerPhoneNumber: props.order.customerPhoneNumber,
      customerProvince,
      customerZipCode,
      customerLat: "",
      customerLon: "",
      customerAddress,
      deliveryType: deliveryTypeValue,
      partnerId: props.order.partnerId,
      orderType: props.order.orderType,
    };
    if (deliver.date) {
      var deliveryDate = convertPersianDigit2English(
        deliver.format("YYYY-MM-DD")
      );
    } else {
      var deliveryDate = deliver;
    }
    const payload = {
      deliveryType: deliveryTypeValue,
      deliveryDate,
      fulfillmentTypeId,
      courierId,
      deliveryServiceId,
      cutoffId,
      deliveryStartTime: convertPersianDigit2English(
        deliveryTime.substring(0, 2).concat(":00:00")
      ),
      deliveryEndTime: convertPersianDigit2English(
        deliveryTime.substring(3, 5).concat(":00:00")
      ),
      id: props.order.id,
      centerId: props.order.centerId,
    };

    const body = {
      ...removeEmptyValueObject(payload),
      fulfillmentWarehouseId: props.order.fulfillmentWarehouseId,
      codValue: props.order.codValue,
      ...removeEmptyValueObject(customerInfo),
    };

    ordersRepository
      .updateOrder({ payload: { body } })
      .then((res) => {
        handleNotfication("سفارش با موفقیت ویرایش شد", "success");
        setEditMode(false);
        history.go(0);
      })
      .catch((err) => {
        handleError(err);
      });
  };
  const handleClose = () => {
    setOpenConfirmUpdateState(false);
  };

  const changeStatusOrder = async () => {
    try {
      await ordersRepository.updateOrderStatus({
        payload: {
          id: props.order.id,
          body: { status: previewState.replace(/"/g, "") },
        },
      });
      handleClose();
    } catch (err) {
      handleError(err);
    }
  };

  useEffect(() => {
    setValue("deliveryDate", formattedDate);
    setDateInDatePiker(formattedDate);
    const fetchFillmentTypes = async () => {
      const isFromCenter = props.order.orderType === "FROM_CENTER";
      try {
        const { res, ok } = await fillmentTypes("order", isFromCenter);
        if (ok) setStateFillmentTypes(res);
      } catch (error) {
        handleError(error);
      }
    };
    fetchFillmentTypes();
  }, [props.order]);

  useEffect(() => {
    if (
      values.fulfillmentTypeId &&
      typeof values.fulfillmentTypeId === "number"
    ) {
      const fetchShippingDefinitions = async () => {
        try {
          const { res, ok } = await shippingDefinitions(
            Number(values.fulfillmentTypeId)
          );
          if (ok) setshippingdefinitions(res.shippingDefinitionList);
        } catch (error) {
          handleError(error);
        }
      };
      fetchShippingDefinitions();
      !editMode && setValue("cutoffId", "");
      if (values.fulfillmentTypeId !== props.order.fulfillmentTypeId) {
        setValue("courierId", "");
      }
    }
  }, [values.fulfillmentTypeId, editMode]);

  useEffect(() => {
    const selectedFulfillmentType = stateFillmentTypes.find(
      (item: any) => item.id === fulfillmentTypeId
    );
    if (selectedFulfillmentType) {
      setIsDisabledDeliveryService(
        selectedFulfillmentType.deliveryServiceDisabled
      );
    }
  }, [fulfillmentTypeId, stateFillmentTypes]);

  useEffect(() => {
    const getCourierList = () => {
      if (shippingdefinitions.length === 1) {
        const ress = shippingdefinitions.flatMap(
          (item: any) => item.deliveryServiceDTO
        );
        setValue("deliveryServiceId", ress[0].id);
        return ress[0];
      } else {
        const selectedDefinition = shippingdefinitions.find(
          (item: any) => item.deliveryServiceDTO.id === deliveryServiceId
        );
        return selectedDefinition ? selectedDefinition.deliveryServiceDTO : [];
      }
    };
    const courierList = getCourierList();
    setCurierDTOList(courierList.courierDTOList);
  }, [deliveryServiceId, shippingdefinitions]);

  useEffect(() => {
    if (listCutoff.length > 0) {
      const rse = listCutoff.find((item: any) => item.id === cutoffId);
      setDeliveryTime(rse?.value);
    }
  }, [listCutoff, cutoffId]);

  useEffect(() => {
    if (editMode) setValue("courierId", courierId);
  }, [editMode]);

  useEffect(() => {
    if (curierDTOList) {
      const res = curierDTOList.find((item: any) => item.id === courierId);
      console.log(22222222222222222222222, res?.orderDeliveryTypeDTO.name);
      setDeliveryTypeValue(res?.orderDeliveryTypeDTO.name);
    }
  }, [courierId]);

  useEffect(() => {
    setValue("cutoffId", "");
  }, [fulfillmentTypeId, courierId, deliveryDate]);

  useEffect(() => {
    setValue("courierId", "");
  }, [deliveryServiceId]);

  return (
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <form onSubmit={handleSubmit(handleUpdateOrders)}>
        <Card className={classes.card}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"وضعیت تحویل:  "}</span>
                <Can
                  role={authContext.user.role}
                  perform="orders:changeOrderStatus"
                  yes={() => (
                    <FormControl style={{ width: "100%" }}>
                      <Icon
                        path={mdiPencilOutline}
                        size={1}
                        className={classes.changStatusIcon}
                      />
                      <Select
                        className={classes.changStatusBox}
                        fullWidth
                        inputProps={{
                          name: "name",
                          id: "uncontrolled-native",
                        }}
                        name={"status"}
                        id={props.order.rubikaId}
                        value={[{}]}
                        IconComponent={() => null}
                        renderValue={() => (
                          <span className={classes.renderValue}>
                            {translate(props.order.status, "order")}
                          </span>
                        )}>
                        <RadioGroup
                          className={classes.radioGroup}
                          aria-label={"status"}
                          name={"status$"}
                          value={"item"}
                          onChange={(
                            e: React.ChangeEvent<{ value: unknown }>
                          ) =>
                            handleOpenConfirmUpdateState(`"${e.target.value}"`)
                          }>
                          {rulesOrderStatus[props.order.status]?.map(
                            (item: any, index: number) => (
                              <FormControlLabel
                                className={classes.radioGroupItem}
                                key={index}
                                checked={props.order.status === item}
                                value={item}
                                disabled={
                                  rulesAdminChangeOrderStatus[
                                    authContext.user.role
                                  ].indexOf(item) === -1
                                }
                                control={<Radio />}
                                label={translate(item, "order")}
                              />
                            )
                          )}
                        </RadioGroup>
                      </Select>
                    </FormControl>
                  )}
                  no={() => (
                    <span>{translate(props.order.status, "order")}</span>
                  )}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"نوع ارسال:  "}</span>
                <span style={{ flex: 1 }}>
                  {translate(props.order?.deliveryType, "order")}
                </span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"کد پیگیری:  "}</span>
                <span style={{ flex: 1 }}>{props.order?.trackingCode}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"تعداد بسته:  "}</span>
                <span style={{ flex: 1 }}>
                  {props.order?.orderPackages &&
                    props.order?.orderPackages.length}
                </span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"ناوگان حمل:"}</span>
                <span style={{ flex: 1 }}>
                  {props.order.orderTPLTypeName ?? "نامشخص"}
                </span>
              </div>
            </Grid>
            <Divider className={classes.divider} />
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"نوع سفارش:"}</span>
                {editMode ? (
                  <span style={{ flex: 1 }}>
                    <div className={classes.item}>
                      <div
                        style={{ width: "100%" }}
                        data-cy="fulfillmentTypeId">
                        <Controller
                          rules={{ required: true }}
                          style={{ width: "100%" }}
                          control={control}
                          name="fulfillmentTypeId"
                          as={
                            <TextField
                              variant="standard"
                              select
                              fullWidth
                              defaultValue={values.fulfillmentTypeId}
                              disabled={props.order.deliveryTypeValue === ""}
                              error={
                                !!errors.fulfillmentTypeId &&
                                !!errors.fulfillmentTypeId
                              }>
                              {stateFillmentTypes.map((item, index) => {
                                return (
                                  <MenuItem key={index} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          }
                        />
                        <FormHelperText error focused>
                          {errors?.fulfillmentTypeId &&
                            " بازه تحویل سفارش الزامی میباشد"}
                        </FormHelperText>
                      </div>
                    </div>
                  </span>
                ) : (
                  <span style={{ flex: 1 }}>
                    {props.order.fulfillmentTypeName}
                  </span>
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"خدمات تحویل:"}</span>
                {editMode ? (
                  <span style={{ flex: 1 }}>
                    <div className={classes.item}>
                      <div
                        style={{ width: "100%" }}
                        data-cy="deliveryServiceId">
                        <Controller
                          rules={{ required: true }}
                          style={{ width: "100%" }}
                          control={control}
                          name="deliveryServiceId"
                          as={
                            <TextField
                              variant="standard"
                              select
                              fullWidth
                              error={
                                !!errors.deliveryServiceId &&
                                !!errors.deliveryServiceId
                              }>
                              {shippingdefinitions?.map(
                                (item: any, index: number) => (
                                  <MenuItem
                                    key={index}
                                    data-cy={item.deliveryServiceDTO.id}
                                    value={item.deliveryServiceDTO.id}>
                                    {item.deliveryServiceDTO.name}
                                  </MenuItem>
                                )
                              )}
                            </TextField>
                          }
                        />
                        <FormHelperText error focused>
                          {errors?.deliveryServiceId &&
                            " بازه خدمات تحویل الزامی میباشد"}
                        </FormHelperText>
                      </div>
                    </div>
                  </span>
                ) : (
                  <span style={{ flex: 1 }}>
                    {props.order.deliveryServiceName}
                  </span>
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"نوع ناوگان:"}</span>
                {editMode ? (
                  <span style={{ flex: 1 }}>
                    <div className={classes.item}>
                      <div style={{ width: "100%" }} data-cy="courierId">
                        <Controller
                          rules={{ required: true }}
                          style={{ width: "100%" }}
                          control={control}
                          name="courierId"
                          as={
                            <TextField
                              variant="standard"
                              select
                              fullWidth
                              error={!!errors.courierId && !!errors.courierId}>
                              {curierDTOList?.map((item, index) => {
                                return (
                                  <MenuItem
                                    key={index}
                                    id={item.id}
                                    value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          }
                        />
                        <FormHelperText error focused>
                          {errors?.courierId &&
                            " بازه نوع ناوگان الزامی میباشد"}
                        </FormHelperText>
                      </div>
                    </div>
                  </span>
                ) : (
                  <span style={{ flex: 1 }}>{props.order.courierName}</span>
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{" تاریخ ثبت:  "}</span>
                <span style={{ flex: 1 }}>
                  {props.order.registrationDate &&
                    `${jMoment(props.order.registrationDate, "YYYY/MM/DD")
                      .locale("fa")
                      .format("jYYYY/jMM/jDD")}`}
                </span>
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"تاریخ تحویل:  "}</span>
                {editMode ? (
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <Controller
                      rules={{ required: true }}
                      name="deliveryDate"
                      control={control}
                      as={
                        <DatePicker
                          id="deliveryDate"
                          name="deliveryDate"
                          format="jYYYY/jMM/jDD"
                          minDate={dateInDatePiker}
                          shouldDisableDate={(d: any) => d?._d.getDay() === 5}
                          disablePast
                          okLabel="تأیید"
                          cancelLabel="لغو"
                          value={deliveryDate}
                          onChange={handleDeliveryDateChange}
                          error={errors.hasOwnProperty("deliveryDate")}
                          helperText={
                            errors.deliveryDate && errors.deliveryDate.message
                          }
                        />
                      }
                    />
                    <FormHelperText error focused>
                      {errors.deliveryDate && "تاریخ تحویل سفارش الزامی میباشد"}
                    </FormHelperText>
                  </MuiPickersUtilsProvider>
                ) : (
                  <span style={{ flex: 1 }}>
                    {props.order.deliveryDate &&
                      `${jMoment(props.order.deliveryDate, "YYYY/MM/DD")
                        .locale("fa")
                        .format("jYYYY/jMM/jDD")}`}
                  </span>
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"بازه تحویل:  "}</span>
                {editMode ? (
                  <span style={{ flex: 1 }}>
                    <div className={classes.item}>
                      <div style={{ width: "100%" }} data-cy="cutoffId">
                        <Controller
                          rules={{ required: true }}
                          style={{ width: "100%" }}
                          control={control}
                          name="cutoffId"
                          as={
                            <TextField
                              variant="standard"
                              select
                              fullWidth
                              disabled={props.order.deliveryTypeValue === ""}
                              error={!!errors.cutoffId && !!errors.cutoffId}>
                              {listCutoff.map((item) => {
                                return (
                                  <MenuItem
                                    disabled={!item.disableCutoff}
                                    value={item.id}
                                    id={item.id}>
                                    {item.label}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          }
                        />
                        <FormHelperText error focused>
                          {errors?.cutoffId &&
                            " بازه تحویل سفارش الزامی میباشد"}
                        </FormHelperText>
                      </div>
                    </div>
                  </span>
                ) : (
                  <span style={{ flex: 1 }}>
                    {`${jMoment(props.order.deliveryStartTime, "HH:mm:ss")
                      .locale("fa")
                      .format("HH:mm")}`}
                    {` - ${jMoment(props.order.deliveryEndTime, "HH:mm:ss")
                      .locale("fa")
                      .format("HH:mm")}`}
                  </span>
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"استان:  "}</span>
                {editMode ? (
                  <Controller
                    name="customerProvince"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                    }}
                    as={
                      <TextField
                        name="customerProvince"
                        variant="standard"
                        defaultValue={formaterPhoneNumber(
                          props.order.customerProvince
                        )}
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(props.order.customerProvince)}
                  </span>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"شهر:  "}</span>
                {editMode ? (
                  <Controller
                    name="customerCity"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                    }}
                    as={
                      <TextField
                        name="customerCity"
                        variant="standard"
                        defaultValue={formaterPhoneNumber(
                          props.order.customerCity
                        )}
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(props.order.customerCity)}
                  </span>
                )}
              </div>
            </Grid>
            <Divider className={classes.divider} />
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"نام:  "}</span>
                {editMode ? (
                  <Controller
                    name="customerName"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                    }}
                    as={
                      <TextField
                        name="customerName"
                        variant="standard"
                        defaultValue={props.order.customerName}
                        error={!!errors.customerName && !!errors.customerName}
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>{props.order.customerName}</span>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"شماره همراه:  "}</span>
                {editMode ? (
                  <Controller
                    name="customerMobileNumber"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                      minLength: 11,
                      maxLength: 11,
                    }}
                    as={
                      <TextField
                        name="customerMobileNumber"
                        variant="standard"
                        defaultValue={formaterPhoneNumber(
                          props.order.customerMobileNumber
                        )}
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(props.order.customerMobileNumber)}
                  </span>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"کد ملی:  "}</span>
                {editMode ? (
                  <Controller
                    name="customerNationalCode"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                      minLength: 10,
                      maxLength: 10,
                    }}
                    as={
                      <TextField
                        name="customerNationalCode"
                        variant="standard"
                        defaultValue={formaterPhoneNumber(
                          props.order.customerNationalCode
                        )}
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(props.order.customerNationalCode)}
                  </span>
                )}
              </div>
              <FormHelperText error focused>
                {errors?.customerNationalCode && "کد ملی اشتباه وارد شده است"}
              </FormHelperText>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"آدرس:  "}</span>
                {editMode ? (
                  <Controller
                    name="customerAddress"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                      // minLength: 10,
                    }}
                    as={
                      <TextField
                        name="customerAddress"
                        fullWidth
                        variant="standard"
                        defaultValue={
                          props.order.customerAddress &&
                          props.order.customerAddress
                        }
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {props.order.customerAddress && props.order.customerAddress}
                  </span>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"کد پستی:  "}</span>
                {editMode ? (
                  <Controller
                    name="customerZipCode"
                    control={control}
                    as={
                      <TextField
                        defaultValue={props.order.customerZipCode}
                        name="customerZipCode"
                        variant="standard"
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(props.order.customerZipCode)}
                  </span>
                )}
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"توضیحات:  "}</span>
                <span style={{ flex: 1 }}>
                  {props.order.description && props.order.description}
                </span>
              </div>
            </Grid>
            {props.order.senderName && (
              <Grid item xs={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{"نام فرستنده:"}</span>
                  <span style={{ flex: 1 }}>{props.order.senderName}</span>
                </div>
              </Grid>
            )}
            <Divider className={classes.divider} />
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <Can
                  role={authContext.user.role}
                  perform="orders:post-tracking-code"
                  yes={() => (
                    <React.Fragment>
                      <TextField
                        id="outlined-basic"
                        value={postTrackingCode}
                        onChange={handleChangeTrackingCode}
                        size={"small"}
                        variant="outlined"
                        placeholder="کد رهگیری پست"
                        fullWidth
                      />
                      <Button
                        style={{ marginRight: "5px" }}
                        variant="contained"
                        color="secondary"
                        onClick={submitPostTrackingCode}
                        disabled
                        size={"medium"}>{`ثبت`}</Button>
                    </React.Fragment>
                  )}
                  no={() => (
                    <span style={{ flex: 1 }}>
                      {props.order?.postTrackingCode}
                    </span>
                  )}
                />
              </div>
            </Grid>
            {props.order.postOrders &&
              props.order.postOrders.map((postOrder: any) => {
                return (
                  <Can
                    role={authContext.user.role}
                    perform="orders-detail:postOrders"
                    yes={() => (
                      <Grid item container xs={12}>
                        <Grid item xs={12}>
                          <div className={classes.item}>
                            <span className={classes.label}>
                              {"شناسه مرسوله:  "}
                            </span>
                            <span style={{ flex: 1 }}>
                              {postOrder.id && postOrder.id}
                            </span>
                          </div>
                        </Grid>
                        <Grid item xs={12}>
                          <div className={classes.item}>
                            <span className={classes.label}>
                              {"کد رهگیری پست:  "}
                            </span>
                            <span style={{ flex: 1 }}>
                              {postOrder.barcode && postOrder.barcode}
                            </span>
                          </div>
                        </Grid>
                      </Grid>
                    )}
                  />
                );
              })}
            <Divider className={classes.divider} />
            <Grid item xs={12}>
              <div>
                {editMode ? (
                  <input
                    type="submit"
                    value={"ثبت تغییرات"}
                    className={classes.submitbtn}
                  />
                ) : (
                  <Button
                    fullWidth
                    onClick={() => setEditMode(true)}
                    color="primary"
                    size="medium"
                    variant="contained">
                    تغییر سفارش
                  </Button>
                )}
              </div>
            </Grid>
          </Grid>
        </Card>
      </form>
      <Dialog
        fullWidth
        open={openConfirmUpdateState}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title">
        <DialogContent>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}>
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            {`از تغییر تگ وضعیت سفارش
                "${translate(props.order.status, "order")}"
                به
            " ${translate(previewState.replace(/"/g, "") as Status, "order")}"
                مطمئن هستید؟`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large">
                {"خیر"}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={changeStatusOrder}
                size="large">
                {"بله"}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

export default Detailwithedit;
